import { createContext } from 'react';

export type SendPaylinkCtx = {
  showSendPaylinkSuccessAlert: boolean;
  showSendPaylinkErrorAlert: boolean;
  sendPaylinkError: string;
  payLink: string;
};

const SendPaylinkContext = createContext<SendPaylinkCtx>({
  showSendPaylinkSuccessAlert: false,
  showSendPaylinkErrorAlert: false,
  sendPaylinkError: '',
  payLink: '',
});

export default SendPaylinkContext;